import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useDropdownKeyboardNavigation } from '../../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import NavigationList from '../../../../components/NavigationList/NavigationList';
import useKeyboardNavigation from '../../../../components/Custom_Hooks/useKeyboardNavigation';
import { saveChartOfAccountsState } from '../../../../redux/actions/action-creator';

const ChartOfAccount = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const isBackNavigation = navigationType === 'POP';
  const persistedState = useSelector(state => state.common.chart_of_accounts_persisted_state?.chartOfAccountNav);
  const localSelectionRef = useRef(null);

  const keyMap = {
    'g': '/chart-of-account-accounting-master-group',
    'l': '/chart-of-account-accounting-master-ledger',
    'v': '/chart-of-account-accounting-master-voucherstype',
    's': '/chart-of-account-invmas-stockgroup',
    'c': '/chart-of-account-invmas-stockcategory',
    'y': '/chart-of-account-invmas-stockcompany',
    'i': '/chart-of-account-invmas-stockitem',
    'u': '/chart-of-account-invmas-unit',
    'o': '/chart-of-account-invmas-godown',
  };

  useKeyboardNavigation(keyMap);

  const data = [
    // Accounting Master
    { category: "Accounting Master", to: "/chart-of-account-accounting-master-group", text: "Group" },
    { category: "Accounting Master", to: "/chart-of-account-accounting-master-ledger", text: "Ledger" },
    { category: "Accounting Master", to: "/chart-of-account-accounting-master-voucherstype", text: "Vouchers Type" },
    // Inventory Master
    { category: "Inventory Master", to: "/chart-of-account-invmas-stockgroup", text: "Stock Group" },
    { category: "Inventory Master", to: "/chart-of-account-invmas-stockcategory", text: "Stock Category" },
    { category: "Inventory Master", to: "/chart-of-account-invmas-stockcompany", text: "Stock Company" },
    { category: "Inventory Master", to: "/chart-of-account-invmas-stockitem", text: "Stock Item" },
    { category: "Inventory Master", to: "/chart-of-account-invmas-unit", text: "Unit" },
    { category: "Inventory Master", to: "/chart-of-account-invmas-godown", text: "Godown" }
  ];

  // Compute initialIndex based on navigation type
  const computeInitialIndex = () => {
    const itemNameToRestore = isBackNavigation ? persistedState?.selectedItemName : localSelectionRef.current;
    if (itemNameToRestore) {
      const index = data.findIndex(item => item.text === itemNameToRestore);
      if (index !== -1) return index;
    }
    return 0;
  };

  const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
    items: data,
    state: location?.pathname === '/chartofaccountmasters' ? true : false,
    initialIndex: computeInitialIndex(),
    onItemSelect: (item) => {
      if (location?.pathname === '/chartofaccountmasters') {
        dispatch(saveChartOfAccountsState({ chartOfAccountNav: { selectedItemName: item.text, selectedItemIndex } }));
        navigate(item.to)
      }
    },

  });

  // Restore selection when navigating back to this page
  useEffect(() => {
    if (location?.pathname === '/chartofaccountmasters') {
      const itemNameToRestore = isBackNavigation ? persistedState?.selectedItemName : localSelectionRef.current;
      if (itemNameToRestore) {
        const index = data.findIndex(item => item.text === itemNameToRestore);
        if (index !== -1) setSelectedItemIndex(index);
        else setSelectedItemIndex(0);
      } else {
        setSelectedItemIndex(0);
      }
    }
  }, [location?.pathname]);

  // Track selection changes for persistence
  useEffect(() => {
    if (selectedItemIndex !== undefined && data[selectedItemIndex]) {
      const name = data[selectedItemIndex].text;
      localSelectionRef.current = name;
      if (name && location?.pathname === '/chartofaccountmasters') {
        dispatch(saveChartOfAccountsState({ chartOfAccountNav: { selectedItemName: name, selectedItemIndex } }));
      }
    }
  }, [selectedItemIndex]);
  return (
    <NavigationList
      data={data}
      selectedItemIndex={selectedItemIndex}
      setSelectedItemIndex={setSelectedItemIndex}
      title='Chart Of Account'
      first_heading='Accounting Master'
      secound_heading='Inventory Masters'

    />
  )
}

export default React.memo(ChartOfAccount);
